import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom';
import OneDaciaHeader from '@makolab/library-react/dist/OneDaciaHeader';
import OneFooter from '@makolab/library-react/dist/OneFooter';
import console from '@makolab/library-react/dist/console';
import JssProvider from 'react-jss/lib/JssProvider';
import {MuiThemeProvider, withStyles} from '@material-ui/core/styles';

import {jss, generateClassName} from './styles/jss-config';
import theme from './styles/theme-default';
import globalStyles from './styles/global.jss';
import {ObserveConfigComponent} from './observe-config';

const globalStylesElement = document.createElement('div');
const GlobalStyles = withStyles(globalStyles)(() => null);

globalStylesElement.style.display = 'none';
globalStylesElement.id = 'mlb-style-wrapper';
document.getElementsByTagName('body')[0].prepend(globalStylesElement);
ReactDOM.render((
  <JssProvider
    jss={jss}
    generateClassName={generateClassName}
  >
    <MuiThemeProvider theme={theme}>
      <GlobalStyles />
    </MuiThemeProvider>
  </JssProvider>), globalStylesElement);

// header renderer
// we split rendering into two try catch blocks to not stop rendering second element when first one throws
(() => {
  const headerEl = document.getElementById('mlb-one-header');

  if (!headerEl) {
    console.warn('Header #mlb-one-header element not found, skipping');
    return;
  }

  try {
    ReactDOM.render((
      <ObserveConfigComponent
        id="mlb-one-header-config"
        render={({config}) => {
          return (
            <JssProvider
              jss={jss}
              generateClassName={generateClassName}
            >
              <MuiThemeProvider theme={theme}>
                <OneDaciaHeader headerZone={config} />
              </MuiThemeProvider>
            </JssProvider>
          );
        }}
      />
    ), headerEl);
  } catch (e) {
    console.error(e);
  }
})();

// footer renderer
(() => {
  const footerEl = document.getElementById('mlb-one-footer');

  if (!footerEl) {
    console.warn('Footer #mlb-one-footer element not found, skipping');
    return;
  }

  try {
    ReactDOM.render((
      <ObserveConfigComponent
        id="mlb-one-footer-config"
        render={({config}) => {
          return (
            <JssProvider
              jss={jss}
              generateClassName={generateClassName}
            >
              <MuiThemeProvider theme={theme}>
                <OneFooter footerZone={config} />
              </MuiThemeProvider>
            </JssProvider>
          );
        }} />
    ), footerEl);
  } catch (e) {
    console.error(e);
  }
})();




// WEBPACK FOOTER //
// ./src/index.js